import { cn } from '@/lib/cn';
import { formatPoints } from '@/lib/format';

/**
 * Story points. One point is one day and five is a week, so the pill is sized
 * to be read in a column of cards, in mono, with tabular figures.
 *
 * `null` means unestimated, which is a real state worth seeing rather than
 * hiding - capacity reporting counts unestimated tasks separately.
 */
export function PointsPill({
  points,
  className,
  size = 'md',
}: {
  points: number | null;
  className?: string;
  size?: 'sm' | 'md';
}) {
  const unestimated = points === null;

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded-sm border font-mono font-medium tnum',
        size === 'sm' ? 'h-5 min-w-8 px-1.5 text-nano' : 'h-6 min-w-9 px-2 text-micro',
        unestimated
          ? 'border-dashed border-line-strong bg-transparent text-subtle'
          : 'border-line bg-sunken text-ink',
        className,
      )}
      title={unestimated ? 'Not estimated' : `${formatPoints(points)} story points`}
    >
      {unestimated ? '?' : `${formatPoints(points)}p`}
    </span>
  );
}
